import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

// Lands here after Emergent Google sign-in: the URL fragment carries a
// one-time session_id which the backend exchanges for a session cookie.
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    // one-time exchange only — StrictMode-safe via ref
    if (processed.current) return;
    processed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const run = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data }, replace: true });
      } catch {
        navigate("/dashboard", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-paper">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/50">Signing you in…</p>
    </div>
  );
};
